import { gql } from '@apollo/client'

export const GET_PAST_TRANSFER_OFFERS = gql`
  query GetPastTransferOffers($fantasyLeagueId: ID!, $limit: Int, $offset: Int) {
    fantasyLeagueMemberPastTransferOffers(
      fantasyLeagueId: $fantasyLeagueId
      limit: $limit
      offset: $offset
    ) {
      id
      amount
      status
      createdAt
      releaseClause
      player {
        id
        createdAt
        nick
        name
        lastName
        role
        marketValue
        image
        totalScore
        lastWeekScore
        lastWeekNumber
        team {
          id
          competition {
            id
            code
            displayName
            rank
          }
          createdAt
          nameShow
          shortName
          shield
        }
      }
      bidder {
        id
        teamName
      }
      seller {
        id
        teamName
      }
    }
  }
`
